import LogoWhite from 'ui/assets/envio-white.png';
import { formatDate } from 'utilities/common';

const Footer = () => {
  return (
    <footer className="footer bg-secondary d-print-none">
      <div className="container py-3 py-md-5">
        <div className="row text-start text-light">
          <div className="col-lg-4">
            <div>
              <img src={LogoWhite} alt="" className="navbar-brand-image" />
            </div>
            <div className="pt-3 mt-n1 pt-md-5">
              <p className="mb-3 fs-7">
                Copyright @ {formatDate(Date.now(), 'YYYY')} envio.co.id <br />{' '}
                All rights reserved.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div>
              <p className="mb-0 fw-bolder fs-6">Email</p>
              <p className="fs-7 mb-0 mb-md-2 pb-md-1">support@envio.co.id</p>
            </div>
            <div className="pt-3 pt-md-4">
              <p className="mb-0 fw-bolder fs-6">Work Hour</p>
              <p className="fs-7">Monday - Friday, 09.00 - 21.00 GMT +7</p>
            </div>
          </div>
          <div className="col-lg-4">
            <p className="mb-0 fw-bolder fs-6">Address</p>
            <p className="fs-7">
              Jl. Puri Kembangan No.57F, RT.11/RW.5,
              <br /> Kembangan Selatan, Kec. Kembangan, Kota Jakarta Barat.
              <br /> Daerah Khusus Ibukota Jakarta 11610
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
